/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"

export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

export type AttachmentFragment = {
  __typename: "AttachmentType"
  id: string
  createdAt?: string | null
  updatedAt?: string | null
  fileName: string
  title?: string | null
  category?: string | null
  position?: number | null
  mimeType?: string | null
  extension?: string | null
  name?: string | null
  readUrl: string
  writeUrl?: { __typename: "AttachmentURL"; url: string; fields: any } | null
}

export type AttachmentAcceptedFileTypesFragment = {
  __typename: "AttachmentAcceptedFileType"
  id: string
  createdAt: string
  updatedAt: string
  extension: string
  mimeType: string
  categories: Array<string>
}

export const AttachmentFragmentDoc = gql`
  fragment Attachment on AttachmentType {
    id
    createdAt
    updatedAt
    fileName
    title
    category
    position
    mimeType
    extension
    name
    readUrl
    writeUrl @type(name: "AttachmentURL") {
      url
      fields
    }
  }
`
export const AttachmentAcceptedFileTypesFragmentDoc = gql`
  fragment AttachmentAcceptedFileTypes on AttachmentAcceptedFileType {
    id
    createdAt
    updatedAt
    extension
    mimeType
    categories
  }
`
